import HttpClient from "./HttpClient";

class AuthRepository {
  private http = HttpClient.getInstance();

  async login(login: string, password: string): Promise<any> {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.http.post("api/v1/login-associates", {
          login,
          password,
        });
        resolve(response);
      } catch (error) {
        console.error("Error al iniciar sesión:", error);
        reject(error);
      }
    });
  }

  async checkAssociate(dni: string): Promise<any> {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.http.post("/api/v1/associates/register", {
          dni,
        });
        resolve(response);
      } catch (error) {
        console.error("Error al verificar el asociado:", error);
        reject(error);
      }
    });
  }
  async confirmEmail(dni: string, email: string): Promise<any> {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.http.post("/api/v1/confirm/email", {
          dni,
          email,
        });
        resolve(response);
      } catch (error) {
        console.error("Error al confirmar el correo:", error);
        reject(error);
      }
    });
  }

  async confirmPhoneNumber(
    dni: string,
    phoneNumber: string,
    idSocio: string
  ): Promise<any> {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.http.post("/api/v1/confirm/born", {
          dni,
          phone_number: phoneNumber,
          idsocio: idSocio,
        });
        resolve(response);
      } catch (error) {
        console.error("Error al confirmar número de teléfono:", error);
        reject(error);
      }
    });
  }

  async confirmPassword(payload: {
    dni: string;
    question: string;
    answer: string;
    password: string;
    email: string;
  }): Promise<any> {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.http.post(
          "/api/v1/confirm/password",
          payload
        );
        resolve(response);
      } catch (error) {
        console.error("Error al confirmar la contraseña:", error);
        reject(error);
      }
    });
  }

  async changePassword(payload: {
    dni: string;
    idsocio: string;
    new_password: string;
    new_password_confirmation: string;
  }): Promise<any> {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.http.post(
          "/api/v1/recovery-password/change-password",
          payload
        );
        resolve(response);
      } catch (error) {
        console.error("Error al cambiar la contraseña:", error);
        reject(error);
      }
    });
  }
  async confirmId(payload: { dni: string; idsocio: string }): Promise<any> {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.http.post(
          "/api/v1/recovery-password/confirm-code",
          payload
        );
        resolve(response);
      } catch (error) {
        console.error("Error al confirmar ID:", error);
        reject(error);
      }
    });
  }

  async confirmData(payload: {
    dni: string;
    idsocio: string;
    answer: string;
  }): Promise<any> {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.http.post(
          "/api/v1/recovery-password/confirm-data",
          payload
        );
        resolve(response);
      } catch (error) {
        console.error("Error al confirmar datos:", error);
        reject(error);
      }
    });
  }
  async logout(): Promise<void> {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        await this.http.post("/logout");
        resolve();
      } catch (error) {
        console.error("Error al cerrar sesión:", error);
        reject(error);
      }
    });
  }
}

export default new AuthRepository();
